<script setup lang="ts">
defineProps<{
  isLoading: boolean;
}>();
</script>
<template>
  <div v-if="isLoading" class="flex items-center justify-center h-full">
    <div
      class="w-10 h-10 border-4 border-gray-200 border-t-primary rounded-full animate-spin"
    ></div>
  </div>
</template>
